/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import clsx from 'clsx';
import React, { useEffect, useState, useContext } from 'react';
import { BarChart, Bar, XAxis, CartesianGrid, Tooltip, Legend, LabelList } from 'recharts';
import { useWindowSize } from '../../hooks/custom-hooks/useSidebarHook';
import useWidgetAPI from '../../hooks/network/useWidgetAPI';
import WidgetDropdown from './WidgetDropdown';
import { AppContext } from '../../context/AppContext';

function TonnageConsumptions({ isSelectedWidget, customerId, projectId, widgetIndex, authToken }) {
  const { getConsumptionsData } = useWidgetAPI();
  const [data, setData] = useState();
  const { widgetDropDownOptions: dropDownOptions } = useContext(AppContext);

  useEffect(() => {
    fetchWidgetData(customerId, projectId);
  }, [customerId, projectId]);

  const fetchWidgetData = async (customerId, projectId) => {
    const query = { customerId, projectId };
    const response = await getConsumptionsData(query);
    setData(response);
  };

  const getGraphData = () => {
    const filteredRecords = data?.groupDeliverdQuantity?.filter(
      (f) => f?.Unit === 'MT' || f?.Unit === 'M2',
    );

    return filteredRecords?.map((record) => ({
      Name: record?.Group,
      Tonnage: Math.round((record.PendingQuantity + record.DeliveredQuantity) * 100) / 100,
    }));
  };

  const renderWidgetBody = () => {
    return (
      <div className='cursor-pointer'>
        <div className='relative mt-4 flex justify-center'>
          <div className='flex h-full w-full flex-shrink-0 justify-center rounded-md'>
            <TonnageConsumptionsBarChart data={getGraphData()} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {isSelectedWidget && (
        <div className='rounded-tr-lg rounded-tl-lg border border-solid border-gray-200 bg-[#FFF5EA] py-3 px-3 text-sm font-semibold'>
          {dropDownOptions?.find((f) => f?.customerID === customerId)?.customerName}
        </div>
      )}
      <div className={clsx( { 'rounded-br-lg rounded-bl-lg': isSelectedWidget }, 'widget-wrapper')}>
        <div className='flex items-start justify-between'>
          <div>
            <p className='text-xs font-semibold text-black break:text-sm'>Contract Consumptions</p>
          </div>
          <div className='m-0 self-start p-0 text-[8px]'>
            {isSelectedWidget && (
              <WidgetDropdown scope='TonnageConsumptions' isSelected widgetIndex={widgetIndex} />
            )}
          </div>
        </div>
        {authToken ? (
          <form action='https://prodash.natsteel.com.sg:8080/v1/auth/ump' method='post'>
            <input type='hidden' name='token' value={authToken} />
            <input type='hidden' name='path' value={'/project-consumption'} />
            <button className='w-full'>{renderWidgetBody()}</button>
          </form>
        ) : (
          renderWidgetBody()
        )}
      </div>
    </div>
  );
}

export default TonnageConsumptions;

// const data = [
//   {
//     name: 'CAB',
//     uv: 4000,
//     pv: 2400,
//     amt: 2400,
//   },
//   {
//     name: 'BAR',
//     uv: 3000,
//     pv: 1398,
//     amt: 2210,
//   },
//   {
//     name: 'MAS',
//     uv: 2000,
//     pv: 9800,
//     amt: 2290,
//   },
//   {
//     name: 'TES',
//     uv: 2780,
//     pv: 3908,
//     amt: 2000,
//   },
//   {
//     name: 'CBG',
//     uv: 1890,
//     pv: 4800,
//     amt: 2181,
//   },
// ];

const renderCustomizedLabel = (props) => {
  const { x, y, width, height, value } = props;
  const radius = 10;

  return (
    <g>
      <text
        className='text-xs'
        x={x + width / 2}
        y={y - radius}
        fill='#003EC4'
        textAnchor='middle'
        dominantBaseline='middle'
      >
        {value}
      </text>
    </g>
  );
};

function TonnageConsumptionsBarChart(props) {
  const { data } = props;
  const [width, height] = useWindowSize();

  return (
    <BarChart
      width={width > 500 ? 480 : width - 80}
      height={300}
      data={data}
      margin={{
        top: 16,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray='3 3' />
      <XAxis dataKey='Name' />

      <Tooltip />
      <Legend />
      <Bar className='rounded-md' dataKey='Tonnage' fill='#003EC4' radius={[8, 8, 0, 0]}>
        <LabelList dataKey='Tonnage' content={renderCustomizedLabel} />
      </Bar>
    </BarChart>
  );
}
